import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyAOLklKaO0sopwx6oymSMhLa01xFTzTs_s",
  authDomain: "trainingsapp-9e56c.firebaseapp.com",
  databaseURL:
    "https://trainingsapp-9e56c-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "trainingsapp-9e56c",
  storageBucket: "trainingsapp-9e56c.appspot.com",
  messagingSenderId: "969822829620",
  appId: "1:969822829620:web:a1e535ceda8b5435dede61",
  measurementId: "G-HE11CBVM7X",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);


